import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  allowedRolesToAssign,
  generateString,
} from "../../helpers/adminHelpers";
import { getRole, getUser } from "../../services/authService";
import {
  addEmailLog,
  assignRoleToUser,
  createUser,
  getAllRoleList,
  getSupplierList,
} from "../../services/dataService";
import { useFormik } from "formik";
import * as yup from "yup";
import { createUserOnboardingSchema } from "../../schema/form";
import { find } from "lodash";
import {
  SuperAdmin,
  SupplierAdmin,
  SupplierFinance,
  SupplierOperations,
} from "../../global-const/permissionName";
import { sendEmail } from "../../services/emailService";
import { getUserCreateMailTemplate } from "../../email-templates/templateGenerator";
import { today } from "../../manager/dateManager";
import { devCCEmails, liveOnboardingEmails } from "../../config/emailRecipient";
import config from "../../config/envConfig";

function UserOnboarding() {
  const user = getUser();
  const userRole = getRole();
  const [roleMaster, setRoleMaster] = useState([]);
  const [supplierMaster, setSupplierMaster] = useState([]);
  const [selectedUser, setSelectedUser] = useState("impex");
  


  useEffect(() => {
    async function getRoles() {
      const response = await getAllRoleList();
      setRoleMaster(response.data);
    }
    async function requestSupplierList() {
      const response = await getSupplierList();
      setSupplierMaster(response.data);
    }
    requestSupplierList();
    getRoles();
  }, []);

  console.log()

  const handleUserOnboarding = async (values) => {
   
    const currentUserRole = getRole();
    try {
      const password = generateString();
      var payload = new FormData();
      var rolePayload = new FormData();
      payload.append("FirstName", values.FirstName);
      payload.append("LastName", values.LastName);
      payload.append("DateOfBirth", values.DateOfBirth);
      payload.append("LoginId", values.LoginId);
      payload.append("Email", values.Email);
      payload.append("MobileNo", values.MobileNo);
      payload.append("HomeTownAddress", values.HomeTownAddress);
      payload.append("Password", password);
      payload.append("ConfirmPassword", password);
      payload.append("GenderId", 0);
      payload.append("CountryId", 0);
      payload.append("StateId", 0);
      payload.append("CityId", 0);
      payload.append("OfficeId", 0);
      payload.append("CreatedBy", values.CreatedBy);
      payload.append("IsMfA", values.IsMFA);
      payload.append("MFADays", values.MFADays);
      if (values.supplier) {
        payload.append("UserType", "SupplierAdmin");
        payload.append("GlobalId", values.supplier.ID);
        payload.append("CompanyName", values.supplier.Name);
      } else if (
        [SupplierAdmin, SupplierFinance, SupplierOperations].includes(
          currentUserRole
        )
      ) {
        payload.append("UserType", "SupplierUser");
        payload.append("GlobalId", user?.userDetails["GlobalId"]);
        payload.append("CompanyName", user?.userDetails.CompanyName);
      } else {
        payload.append("UserType", "ImpexOperationAdmin");
        payload.append("GlobalId", user?.userDetails["GlobalId"]);
        payload.append("CompanyName", user?.userDetails.CompanyName || "Impex");
      }
      const response = await createUser(payload);
      rolePayload.append("ProjectId", 1);
      rolePayload.append("RoleId", values.role.RoleId);
      rolePayload.append("UserId", response.data.Result);
      rolePayload.append("CreatedBy", values.CreatedBy);

      await assignRoleToUser(rolePayload);

      const ImpexAdminguide ="https://s3.eu-west-1.amazonaws.com/docs.quloi.com/Impex/Impex%20Operation%20User%20Guide%20V1.2%20%284%29-1689058294937.pdf";
      const SupplierAdminguide ="https://s3.eu-west-1.amazonaws.com/docs.quloi.com/Impex/Supplier%20%20Operation%20User%20Guide%20V1.2-1685084071290.pdf"
   
        

      await sendEmail({
    
        receiverAddress: values.Email,
        cc: [],
        bcc: config.env === "development" ? devCCEmails : liveOnboardingEmails,
        receiverName: values.FirstName + " " + values.LastName,
        subject: `Welcome aboard ${values.FirstName} ${values.LastName}`,
        HTML: getUserCreateMailTemplate(values, password),
        attachments: [
          {
            
            filename: "Impex Portal User Guide.pdf",
    
            path:user.isImpexAdmin? ImpexAdminguide: SupplierAdminguide,
        
          },
        ],
        templateId: "2",
        alertTime: today(true),
      }) 
     
    
      toast.success("User Created Succesfully");
      await addEmailLog({
        Mailto: values.Email,
        MailCc: "",
        MailSubject: `Welcome aboard ${values.FirstName} ${values.LastName}`,
        FormName: "User Onboarding",
        FunctionalityName: "Admin add new user",
        TriggerDatetime: today(true),
        UId: user.userDetails.UserId,
        HostName: "Test HostName",
        ProjectName: "ImpexPortal",
      });
      formik.resetForm({ value: "" });
    } catch (error) {
      toast.warning(error?.response?.data?.Message);
    }
  };

  const userValidationSchema = yup.object({
    FirstName: yup.string().required("First Name can not be null"),
    LastName: yup.string().required("Last Name can not be null"),
    LoginId: yup
      .string()
      .min(4, "Login Id must have minimum 4 characters")
      .required("User Name can not be null"),
    MobileNo: yup
      .string()
      .min(10, "Please enter 10 digit number")
      .max(10, "Please enter 10 digit number")
      .required("Last Name can not be null"),
    Email: yup.string().email().required("Email can not be null"),
    role: yup.object().required("ID Required"),
    DateOfBirth: yup
      .date()
      .required("Date of birth is required")
      .default(today()),
    HomeTownAddress: yup.string().required("Please enter your address"),
    CreatedBy: yup.number().required("Created by can not be null"),
  });
  const formik = useFormik({
    initialValues: {
      FirstName: "",
      LastName: "",
      LoginId: "",
      MobileNo: "",
      Email: "",
      supplier: null,
      role: null,
      DateOfBirth: today(),
      HomeTownAddress: "",
      CreatedBy: user?.userDetails["UserId"],
      IsMFA: false,
      MFADays: 0,
    },
    validationSchema: userValidationSchema,
    onSubmit: (values) => {
      handleUserOnboarding(values);
    },
  });

  const handleOptionChange = (e) => {
    setSelectedUser(e.target.value);
    formik.handleReset();
  };

  return (
    <>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid item marginTop="20px">
          <Card>
            <CardHeader title="User details" />
            <CardContent>
              {user?.isImpexOperation && user?.isImpexAdmin && (
                <Grid item spacing={2} marginBottom={2} marginLeft={1}>
                  <FormControl>
                    <RadioGroup
                      row
                      value={selectedUser}
                      onChange={handleOptionChange}
                    >
                      <FormControlLabel
                        value="impex"
                        control={<Radio />}
                        label="Impex"
                        componentsProps={{ typography: { variant: "body2" } }}
                      />
                      <FormControlLabel
                        value="supplier"
                        control={<Radio />}
                        label="Supplier"
                        componentsProps={{ typography: { variant: "body2" } }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              )}
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  {createUserOnboardingSchema(
                    allowedRolesToAssign(roleMaster, selectedUser),
                    supplierMaster,
                    selectedUser
                  ).map((current) => {
                    if (current.type === "autocomplete") {
                      return (
                        <Grid item lg={current.wdth} key={current.name}>
                          <Autocomplete
                            options={current.options}
                            getOptionLabel={(option) =>
                              option[current.optionLabel]
                            }
                            fullWidth
                            name={current.name}
                            value={formik.values[current.name]}
                            onChange={(e, value) => {
                              formik.setFieldValue(current.name, value);
                              if (current.name === "supplier" && userRole) {
                                if (value) {
                                  formik.setFieldValue(
                                    "role",
                                    find(roleMaster, {
                                      RoleName: SupplierAdmin,
                                    })
                                  );
                                } else {
                                  formik.setFieldValue("role", null);
                                }
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                InputLabelProps={{
                                  style: { fontSize: 14 },
                                }}
                                label={current.label}
                              />
                            )}
                            disabled={
                              current.name === "role" &&
                              formik.values.supplier &&
                              userRole !== SuperAdmin
                            }
                          />
                        </Grid>
                      );
                    }
                    return (
                      <Grid item lg={current.wdth} key={current.name}>
                        <TextField
                          fullWidth
                          label={current.label}
                          id={current.name}
                          value={formik.values[current.name]}
                          onChange={formik.handleChange}
                          type={current.type}
                          inputProps={{ style: { fontSize: 14 } }}
                          error={
                            formik.touched[current.name] &&
                            Boolean(formik.errors[current.name])
                          }
                          helperText={
                            formik.touched[current.name] &&
                            formik.errors[current.name]
                          }
                          InputLabelProps={{
                            ...(current.type === "date" && { shrink: true }),
                            style: { fontSize: 14 },
                          }}
                        />
                      </Grid>
                    );
                  })}
                  <Grid
                    item
                    spacing={2}
                    lg={2}
                    display="flex"
                    flexDirection="row"
                  >
                    <Grid item alignSelf="center" marginLeft={2}>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          id="IsMFA"
                          name="IsMFA"
                          label="Set MFA"
                          componentsProps={{ typography: { variant: "body1" } }}
                          onChange={formik.handleChange}
                          sx={{ fontSize: "8px" }}
                        />
                      </FormGroup>
                    </Grid>
                  </Grid>
                  {formik.values["IsMFA"] === true && (
                    <Grid item spacing={2} lg={4}>
                      <FormControl fullWidth>
                        <InputLabel id="mfaDays">MFA Days</InputLabel>
                        <Select
                          labelId="MFADays"
                          id="mfaDays"
                          name="MFADays"
                          value={formik.values["MFADays"]}
                          label="MFADays"
                          onChange={formik.handleChange}
                        >
                          {[1, 7, 15, 30, 45, 60].map((item, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={item}
                                selected={item === 0}
                              >
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item lg={12} textAlign="right">
                    <Button type="reset" onClick={() => formik.resetForm()}>
                      Cancel
                    </Button>
                    <Button
                      sx={{ ml: "20px" }}
                      variant="contained"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default UserOnboarding;
